import styled from "styled-components";
import { Colors } from "../../commons/Colors";

export const Container = styled.main`
  text-align: center;
  line-height: 2;
  .top_text{
    margin-bottom: 24px;
    display: inline-block;
  }
  p{
    strong{
      font-size: inherit;
    }
  }


  @media screen and (min-width: 501px) {
  }

  @media (max-width: 500px) {
  }
`